import React, { useEffect } from 'react';
import { Styles } from '@t2c/shared-fe';
import DialogContent from '@mui/material/DialogContent';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import LoadingButton from '@mui/lab/LoadingButton';
import { CustomDialogContainer, CustomDialogTitle } from '../../Common/dialog';
import { FormProvider, RHFTextField } from '@sdf/base';
import { useRenameForm } from '../../hooks';
import Avatar from '@mui/material/Avatar';

interface Props {
  shouldOpenDialog: boolean;
  handleCloseDialog: () => void;
  handleOnClone: (name: string) => void;
  isLoading: boolean;
  thumbnail: string;
}

export const BrollCloneDialog: React.FC<Props> = ({
  shouldOpenDialog,
  handleCloseDialog,
  handleOnClone,
  isLoading,
  thumbnail,
}) => {
  const formMethods = useRenameForm({ initialName: '' });
  const { handleSubmit, setValue } = formMethods;

  const handleFormSubmit = async ({ name }: { name: string }) => {
    if(name?.trim())
      await handleOnClone(name?.trim());
  };

  useEffect(() => {
    if (shouldOpenDialog) {
      setValue('name', '');
    }
  }, [shouldOpenDialog]);

  return (
    <CustomDialogContainer open={shouldOpenDialog} maxWidth="sm">
      <FormProvider methods={formMethods} onSubmit={handleSubmit(handleFormSubmit)}>
        <CustomDialogTitle
          sx={styles.title}
          title={'Clone Video'}
          onClose={isLoading ? () => {} : handleCloseDialog}
        />
        <DialogContent dividers sx={styles.dialogContent}>
          <Stack rowGap={2}>
            <Stack alignItems={'center'}>
              <Avatar alt={'...'} src={thumbnail} sx={{ width: '152px', height: '152px' }} />
            </Stack>

            <RHFTextField
              placeholder="Enter name here..."
              size="small"
              type="text"
              name="name"
              sx={styles.textField}
            />
          </Stack>
          <Stack flexDirection="row" justifyContent="flex-end" alignItems="center" mt={3}>
            <LoadingButton
              type="submit"
              variant="contained"
              sx={styles.saveBtn}
              loading={isLoading}
            >
              Clone
            </LoadingButton>
          </Stack>
        </DialogContent>
      </FormProvider>
    </CustomDialogContainer>
  );
};

const styles: Styles = {
  title: {
    color: (theme) => theme.palette.background.activeBorder,
    paddingBottom: '10px',
    paddingTop: '10px',
  },
  dialogContent: {
    padding: '16px',
    backgroundColor: (theme) => theme.palette.background.secondary
  },
  textField: {
    '& .MuiOutlinedInput-root': {
      border: '1px solid',
      borderRadius: '6px',
      borderColor: (theme) => theme.palette.background.border,
      backgroundColor: (theme) => theme.palette.background.secondary,
      '&:hover': {
        borderColor: (theme) => theme.palette.background.activeBorder,
      },
    },
    '& .MuiOutlinedInput-input::placeholder': {
      color: (theme) => theme.palette.text.placeholder,
    },
  },
  saveBtn: {
    color: (theme) => theme.palette.text.primary,
    boxShadow: 'none',
    minWidth: 150,

  },
};
